module.exports = __webpack_public_path__ + "img/circle-dollar.0b7dd04f.svg";